import { render, staticRenderFns } from "./PutAway.vue?vue&type=template&id=47b90466&scoped=true"
import script from "./PutAway.vue?vue&type=script&lang=js"
export * from "./PutAway.vue?vue&type=script&lang=js"
import style0 from "./PutAway.vue?vue&type=style&index=0&id=47b90466&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b90466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b90466')) {
      api.createRecord('47b90466', component.options)
    } else {
      api.reload('47b90466', component.options)
    }
    module.hot.accept("./PutAway.vue?vue&type=template&id=47b90466&scoped=true", function () {
      api.rerender('47b90466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/traddingWitness/openBidWitness/components/PutAway.vue"
export default component.exports